import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CommitteeContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  margin: '10px',

  '.rowFields': {
    display: 'flex'
  },

  'div.btnContainer': {
    display: 'flex',
    width: '100%',
    marginTop: '1rem',
    justifyContent: 'center',

    'div.left': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-start',
    },

    'div.right': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
})